import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tasks-kanban" }
const _hoisted_2 = { class: "tasks-kanban__header" }
const _hoisted_3 = {
  key: 0,
  class: "tasks-kanban__main"
}
const _hoisted_4 = { class: "tasks-kanban__content" }
const _hoisted_5 = { class: "tasks-kanban__scroll" }
const _hoisted_6 = { class: "tasks-kanban__tools" }
const _hoisted_7 = {
  key: 1,
  class: "is-no-correct"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = {
  key: 2,
  class: "is-no-correct"
}
const _hoisted_10 = {
  key: 3,
  class: "tasks-kanban__no-find-block"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "tasks-kanban__no-find-text" }, [
  /*#__PURE__*/_createTextVNode(" По вашему запросу ничего не "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" найдено ")
], -1)
const _hoisted_12 = { key: 4 }
const _hoisted_13 = { class: "tasks-kanban__skeleton-block" }

import {
  ComputedRef,
  PropType,
  computed,
  inject,
  nextTick,
  onBeforeMount,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from 'vue';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmDraggableSorting,
  DragModel,
  TirPmScrollbar,
  TirPmPopover,
  PopoverPositionEnum,
  TirPmIconView,
  TirPmNotificationModel,
  TirPmNotificationEventBus,
} from 'tir-components';
import {
  PlusIcon,
  EllipsisHorizontalIcon,
  FolderOpenIcon,
  ListBulletIcon,
  MagnifyingGlassIcon,
} from 'tir-style-system/icons/outline';
import {
  TasksKanbanColumnModel,
  TaskModel,
  TasksKanbanGroupingModel,
  TaskStatusModel,
} from './models';
import { useKanbanManager, useTasksKanbanDraggble } from './composables';
import {
  TaskKanbanCard,
  TasksKanbanFilter,
  KanbanLayout,
  KanbanColumn,
  KanbanDraggableSorting,
  TasksKanbanColumnIndicator,
} from './components';
import { TaskViewSettings, TasksKanbanExternalSettings } from './types';
import { TasksKanbanGrouppingTypeEnum, TaskViewElementEnum } from './enums';
import {
  TaskDrawer,
  TaskDrawerSettingsModel,
  TaskDrawerFormDataModel,
  TaskDrawerTaskModel,
  RemoveTaskModal,
} from '@/components';
import { useRouter } from 'vue-router';

import { TaskKanbanAdapterService } from './adapter';
import TirPmSystemMessage from 'tir-pm-system-message/src/tir-pm-system-message.vue';
import { DimondIcon } from 'tir-style-system/icons/solid';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import ProjectQueueTaskListItem from '@/api/Main/dataSource/api/projects/groups/i-service/model/queue-tasks/ProjectQueueTaskListItem';
import SubscribeToQueueTasksRequest from './models/SubscribeToQueueTasksRequest';
import ListenTaskInfoAdapter from './adapter/ListenTaskInfoAdapter';
import TaskKanbanSkeleton from './components/TaskKanbanSkeleton.vue';
import { MiddlewareAdapterService } from '@/router/middleware';
import { AttributesLocalStorageService } from '@/services';
import GetAccessCurrentUserInQueueTaskByIdRequestModel from './models/GetAccessCurrentUserInQueueTaskByIdRequestModel';
import GetAccessCurrentUserInQueueTaskByIdResponseModel from './models/GetAccessCurrentUserInQueueTaskByIdResponseModel';


export default /*#__PURE__*/_defineComponent({
  __name: 'TasksKanban',
  props: {
  /**Настройки */
  settings: {
    type: Object as PropType<TasksKanbanExternalSettings>,
    default: (): TasksKanbanExternalSettings => ({
      showNestedTasks: true,
    }),
  },
  /**ID очереди */
  queueId: {
    type: String,
    required: true,
  },
  /**ID проекта */
  projectId: {
    type: Number,
    required: true,
  },
  /**ID неймспейса */
  namespaceId: {
    type: String,
    required: true,
  },
},
  emits: ["toggle-submenu", "open-options"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();
/**Сервис проверки доступов */
const middlewareService = new MiddlewareAdapterService();
const apiService = new TaskKanbanAdapterService();




/**Информация проекта */
const project = inject('project');
/**Ссылка на компонент шторки задачи */
const $taskDrawer = ref<InstanceType<typeof TaskDrawer>>();
/**Окно удаления задачи */
const $removeTaskModal = ref<InstanceType<typeof RemoveTaskModal>>();

const adapterListen = new ListenTaskInfoAdapter({
  CreateTasksEventFn: updateTask,
  RemoveTaskEventFn: updateTask,
});

const currentQueue = inject('currentQueue') as ComputedRef<ProjectQueueTaskListItem>;
const isCanAddTask = inject('isCanAddTask') as ComputedRef<Boolean>;
/**Индекс колонки, которую можно перетаскивать */
const allowDragColumnIndex = ref<number>();
/**Является ли пользователь админом проекта */
const isProjectAdmin = ref(false);
/**Состояние сброса поиска */
const resetSearchState = ref();
/**Была ли выбрана группировка */
const selectGrouppingState = ref();
/**index колонки */
const columnIndex = ref<number>();
/**Доступы юзера к задаче */
const userAccess = ref<GetAccessCurrentUserInQueueTaskByIdResponseModel>();

/**Переносится ли задача */
const isTransferTask = computed<boolean>(
  () => router.currentRoute.value?.query.isTransferTask == 'true',
);
/**Не передвигаемые группировки */
const nonDraggableGroups = computed<boolean>(() => {
  return (
    grouppingType.value === TasksKanbanGrouppingTypeEnum.Performer ||
    grouppingType.value === TasksKanbanGrouppingTypeEnum.Tag
  );
});

/**
 * * Открыть создание задачи
 * @param column Колонка
 */
const openCreateTask = (column?: TasksKanbanColumnModel) => {
  const groupping = column?.Grouping;
  $taskDrawer.value?.open(
    new TaskDrawerSettingsModel({
      Mode: 'create',
      ProjectId: props.projectId,
      QueueId: props.queueId,
      NamespaceId: props.namespaceId,
      FormData: new TaskDrawerFormDataModel({
        StatusId: groupping?.Status?.Id,
        PriorityId: groupping?.Priority?.Id,
        TypeId: groupping?.Type?.Id,
        PerformerIds: groupping?.Performer?.Id ? [groupping.Performer.Id] : [],
        Tags: groupping?.Tag?.Id ? [groupping.Tag.Id] : [],
      }),
    }),
  );
};

/**Открыть задачу */
const openTaskInDrawer = (taskId: number) => {
  $taskDrawer.value?.open(
    new TaskDrawerSettingsModel({
      Mode: 'edit',
      TaskId: taskId,
    }),
  );
};

/**Обновить драйвер задачи */
const onUpdateTaskDrawer = () => {
  if ('copy' in router.currentRoute.value?.query) {
    $taskDrawer.value?.close();
    checkTaskCopying();
  }
};

/**Обновить колонку с задачами */
const updateColumn = async (task: TaskDrawerTaskModel) => {
  const findColumn = columns.value.find((column) => {
    const groupping = column.Grouping;

    switch (grouppingType.value) {
      case TasksKanbanGrouppingTypeEnum.Status:
        return groupping.Status !== undefined && groupping.Status.Id === task.StatusId;
      case TasksKanbanGrouppingTypeEnum.Priority:
        return groupping.Priority !== undefined && groupping.Priority.Id === task.PriorityId;
      case TasksKanbanGrouppingTypeEnum.Author:
        return groupping.Author !== undefined && groupping.Author.Id === task.OwnerId;
      case TasksKanbanGrouppingTypeEnum.Performer:
        return (
          groupping.Performer !== undefined && task.PerformerIds.includes(groupping.Performer.Id)
        );
      case TasksKanbanGrouppingTypeEnum.Tag:
        return groupping.Tag !== undefined && task.Tags.includes(groupping.Tag.Id);
      case TasksKanbanGrouppingTypeEnum.Type:
        return groupping.Type !== undefined && task.TypeId === groupping.Type.Id;
    }
  });

  if (findColumn) updateTasksInColumn(findColumn);
  else loadAllGrouppedTasks(props.queueId);
};

/**Получение доступов по текущему пользователю в очереди задач по идентификатору */
const getAccessCurrentUserInQueueTask = async () => {
  const response = await apiService.getAccessCurrentUserInQueueTaskById(
    new GetAccessCurrentUserInQueueTaskByIdRequestModel({
      QueueTaskId: props.queueId,
    }),
  );
  if (response.IsSuccess) {
    userAccess.value = response.Value;
  }
};
/**При создании задачи */
const onCreateTask = (task: TaskDrawerTaskModel) => {
  updateColumn(task);
  loadAllGrouppedTasks(props.queueId);
};

/**При обновлении задачи */
const onUpdateTask = () => {
  loadAllGrouppedTasks(props.queueId);
};

function updateTask() {
  loadAllGrouppedTasks(props.queueId);
}
const removeSubtaskItem = () => {
  loadAllGrouppedTasks(props.queueId);
};

const taskViewSettings = computed<TaskViewSettings>(() => ({
  showNestedTasks: props.settings.showNestedTasks,
  viewElements: viewElements.value,
}));

const tasks = ref(new Array<TaskModel>());
const columns = ref(new Array<TasksKanbanColumnModel>());
const loading = ref();

const {
  grouppingType,
  viewElements,
  filter,
  isLoading,
  onScrollColumn,
  loadAllGrouppedTasks,
  loadSubtasks,
  moveTask,
  debounceLoadAllGrouppedTasks,
  updateTasksInColumn,
} = useKanbanManager({
  columns: columns,
  tasks: tasks,
  bottomScrollOffset: 200,
  firstRequestTakeCount: 10,
});

/**Кол-во задач */
const countTasks = computed(() => {
  return tasks.value.map((task) => task).length;
});
/** Флаг, указывающий, что пользователь не является админом НС/Овнером и задач для просмотра нет */
const isRestrictedFromViewingTasks = computed(() => {
  return !userAccess.value?.IsNamespaceAdmin && !userAccess.value?.IsOwner && !countTasks.value;
});
/**Текс для заглушки создания задачи */
const createTaskPlaceholderText = computed(() => {
  return isRestrictedFromViewingTasks.value
    ? 'В данной очереди тикеты для Вас отсутствуют'
    : 'В данной очереди еще нет задач';
});

const tasksIndexed = computed(() =>
  tasks.value.reduce<Record<number | string, TaskModel>>((acc, task) => {
    return {
      ...acc,
      [task.Id]: task,
    };
  }, {}),
);

/**Перетаскиваемые колонки */
const dragColumns = computed(() => {
  return columns.value.map(
    (c, i) =>
      new DragModel({
        Data: c,
        AllowDrag: allowDragColumnIndex.value == i,
        AllowDrop: true,
      }),
  );
});

watch(
  () => props.queueId,
  () => {
    onUpdateQueueId();
    configureCardsByGrouping();
  },
);

watch(() => router.currentRoute.value?.fullPath, onUpdateTaskDrawer);
/**Отслеживание изменения группировки */
watch(
  () => grouppingType.value,
  () => configureCardsByGrouping(),
);

/**Подключение к комнате очереди задачи */
const connectToTaskQueue = async () => {
  await apiService.subscribeToQueueEvent(
    new SubscribeToQueueTasksRequest({
      QueueId: String(router.currentRoute.value.params.queueId),
    }),
  );
};

onUnmounted(() => {
  apiService.udSubscribeToQueueEvent(
    new SubscribeToQueueTasksRequest({
      QueueId: String(router.currentRoute.value.params.queueId),
    }),
  );
});

onMounted(async () => {
  await getAccessCurrentUserInQueueTask();
  denterDataLocalStorage.value = AttributesLocalStorageService.getViewElements(props.queueId) ?? [];
  configureCardsByGrouping();
  apiService.ToggleSubscribe(true);
  onUpdateTaskDrawer();

  // apiService.UpdateQueueTaskStatusEvent.on(updateQueue);
});
onBeforeMount(async () => {
  apiService.ToggleSubscribe(false);

  await connectToTaskQueue();

  // apiService.UpdateQueueTaskStatusEvent.removeListener(updateQueue);
  apiService.UpdateQueueTaskStatusEvent.removeListener(onUpdateQueueId);
  // apiService.UpdateQueueTaskStatusEvent.removeListener(IsCanAddTask);
});

const formData = ref();

/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: message,
      type: isError ? 'error' : 'success',
      group: 'general',
      life: life ?? 2000,
      closable: true,
    }),
  );
};

/**Проверка наличия коипрования задачи */
const checkTaskCopying = async () => {
  const copyTaskId = Number(router.currentRoute.value.query.copy);
  router.replace({ query: {} });

  if (copyTaskId && !isTransferTask.value) {
    const routeParams = router.currentRoute.value?.params;
    $taskDrawer.value?.open(
      new TaskDrawerSettingsModel({
        Mode: 'copy',
        TaskId: copyTaskId,
        ProjectId: Number(routeParams.projectId),
        QueueId: String(routeParams.queueId),
        NamespaceId: String(routeParams.namespaceId),
      }),
    );
  } else {
    await $taskDrawer.value?.getTransferredTaskData();

    router.push({
      name: 'task-detail',
      params: {
        taskId: $taskDrawer.value?.transferTaskId,
      },
    });
  }
};
/**Дефолтный вид карточек в зависимости от группировки */
function configureCardsByGrouping() {
  const dataView = AttributesLocalStorageService.getViewElements(props.queueId) ?? [];
  /**Часто используемые пункты */
  const frequentItems = [
    TaskViewElementEnum.Difficulty,
    TaskViewElementEnum.EstimateTime,
    TaskViewElementEnum.WorkTime,
    TaskViewElementEnum.Type,
  ];

  switch (grouppingType.value) {
    case TasksKanbanGrouppingTypeEnum.Status:
      viewElements.value = Array.from(
        new Set([
          ...dataView,
          TaskViewElementEnum.Performers,
          TaskViewElementEnum.Priority,
          ...frequentItems,
        ]),
      );
      break;
    case TasksKanbanGrouppingTypeEnum.Performer:
      viewElements.value = Array.from(
        new Set([
          ...dataView,
          TaskViewElementEnum.Status,
          TaskViewElementEnum.Priority,
          ...frequentItems,
        ]),
      );
      break;
    case TasksKanbanGrouppingTypeEnum.Priority:
      viewElements.value = Array.from(
        new Set([
          ...dataView,
          TaskViewElementEnum.Status,
          TaskViewElementEnum.Performers,
          ...frequentItems,
        ]),
      );
      break;
    case TasksKanbanGrouppingTypeEnum.Tag:
      viewElements.value = Array.from(
        new Set([
          ...dataView,
          TaskViewElementEnum.Status,
          TaskViewElementEnum.Performers,
          TaskViewElementEnum.Priority,
          ...frequentItems,
        ]),
      );
      break;
    case TasksKanbanGrouppingTypeEnum.Type:
      viewElements.value = Array.from(
        new Set([
          ...dataView,
          TaskViewElementEnum.Status,
          TaskViewElementEnum.Performers,
          TaskViewElementEnum.Priority,
          TaskViewElementEnum.Difficulty,
          TaskViewElementEnum.EstimateTime,
          TaskViewElementEnum.WorkTime,
        ]),
      );
      break;
    case TasksKanbanGrouppingTypeEnum.Author:
      viewElements.value = Array.from(
        new Set([
          ...dataView,
          TaskViewElementEnum.Status,
          TaskViewElementEnum.Priority,
          ...frequentItems,
        ]),
      );
      break;
  }
  loadAllGrouppedTasks(props.queueId);
}

/**При обновлении Id очереди */
async function onUpdateQueueId() {
  grouppingType.value =
    AttributesLocalStorageService.getGrouppingType(props.queueId, 'task-kanban') ??
    TasksKanbanGrouppingTypeEnum.Status;
  viewElements.value =
    AttributesLocalStorageService.getViewElements(props.queueId) ??
    Object.values(TaskViewElementEnum);
  loadAllGrouppedTasks(props.queueId);
  await checkProjectAdmin();
}
/**Проверить является ли пользователь админом проекта */
const checkProjectAdmin = async () => {
  if (CurrentUser.Roles.includes(UserRoleEnum.Owner)) {
    isProjectAdmin.value = true;
    return;
  }

  const projectId = Number(router.currentRoute.value?.params?.projectId);
  if (!projectId) return;

  const response = await middlewareService.CheckProjectAdmin(projectId);
  if (response.IsSuccess) isProjectAdmin.value = !!response.Value;
};
const sortTasks = (taskId: number, column: TasksKanbanColumnModel, orderNumber: number) => {};

const selectGrouppingType = async (_grouppingType: TasksKanbanGrouppingTypeEnum) => {
  isLoading.value = true;
  grouppingType.value = _grouppingType;
  AttributesLocalStorageService.saveGrouppingType(props.queueId, _grouppingType, 'task-kanban');
  debounceLoadAllGrouppedTasks(props.queueId);
};

/**Отправляемые данные в локал сторедж */
const denterDataLocalStorage = ref([]);
const updateViewElements = async (_viewElements: Array<TaskViewElementEnum>) => {
  viewElements.value = _viewElements;
  AttributesLocalStorageService.saveViewElements(props.queueId, _viewElements);
  debounceLoadAllGrouppedTasks(props.queueId);
};

/**Сброси поиска */
const resetSearch = async () => {
  resetSearchState.value = true;
  filter.value.Search = '';
  await loadAllGrouppedTasks(props.queueId);
  resetSearchState.value = false;
};

const {
  isDrag,
  currentDragTask,
  currentDragTaskColumnIndex,
  cleanFlag,
  onAdded,
  onChange,
  onDrag,
  onCancel,
} = useTasksKanbanDraggble(columns, {
  moveTask,
  sortTasks,
});
const sortParameters = async (params) => {
  columns.value.splice(0, columns.value.length);
  columns.value.push(...params.map((x) => x.Data));

  const param = params.map((p) => p.Data.Grouping.Status);

  await apiService.SetList(props.queueId, param);
};
// const isCanAddTask = ref(false);
/**Установка индекса перетаскиваемой колонки */
const setColumnDrag = (index?: number) => {
  allowDragColumnIndex.value = index;
};
/**Установка индекса перетаскиваемой колонки при перетаскивании задачи*/
const setDraggingColumnIndex = (index?: number) => {
  if (columnIndex.value === index) return;
  columnIndex.value = index;
};
/**скролл текущей колонки */
const scrollCurrentColumn = (index: number) => {
  return columnIndex.value === index && !!currentDragTask.value?.Data?.TaskId;
};

function openOptions() {
  emit('open-options', props.queueId);
}
function createTask() {
  openCreateTask();
}
/**Открыть окно удаления задачи */
const openRemoveModal = (id: number, name: string) => {
  $removeTaskModal.value?.open(id, name);
};
/**Удаление задачи из списка */
const onSuccessRemove = (taskId: number) => {
  columns.value.forEach((column) => {
    const haveTask = column.Data.some((t) => t.Data.TaskId == taskId);
    if (haveTask) {
      column.CountTasks--;
      column.Data = column.Data.filter((t) => t.Data.TaskId != taskId);
    }
  });

  loadAllGrouppedTasks(props.queueId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(TasksKanbanFilter), {
        project: _unref(project),
        projectId: __props.projectId,
        "groupping-type": _unref(grouppingType),
        "view-elements": _unref(viewElements),
        resetSearchState: resetSearchState.value,
        filter: _unref(filter),
        "onUpdate:filter": _cache[0] || (_cache[0] = ($event: any) => (_isRef(filter) ? (filter).value = $event : null)),
        "onUpdate:grouppingType": selectGrouppingType,
        "onUpdate:viewElements": updateViewElements,
        onOnSearch: _cache[1] || (_cache[1] = ($event: any) => (_unref(loadAllGrouppedTasks)(__props.queueId))),
        isDisabled: !_unref(currentQueue)?.IsConfigured
      }, null, 8, ["project", "projectId", "groupping-type", "view-elements", "resetSearchState", "filter", "isDisabled"]),
      _createVNode(_unref(TirPmButton), {
        class: "tasks-kanban__header__add",
        variant: _unref(TirPmButtonVariantEnum).PrimaryState,
        size: _unref(TirPmButtonSizeEnum).Small,
        onClick: openCreateTask,
        isDisabled: !_unref(currentQueue)?.IsConfigured || !_unref(isCanAddTask)
      }, {
        leftSlot: _withCtx(() => [
          _createVNode(_unref(PlusIcon))
        ]),
        _: 1
      }, 8, ["variant", "size", "isDisabled"])
    ]),
    (tasks.value.length && columns.value.length && _unref(currentQueue).IsConfigured)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(KanbanLayout), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(TirPmScrollbar), { style: {"max-width":"calc(100vw - 12rem)"} }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TirPmDraggableSorting), {
                        vertical: "",
                        "skip-edge": "",
                        class: _normalizeClass(["tasks-kanban__columns", {
                  'tasks-kanban__columns--no-drag': nonDraggableGroups.value,
                }]),
                        data: dragColumns.value,
                        indent: 0,
                        onChange: sortParameters,
                        style: {"margin-bottom":"0.5rem"}
                      }, {
                        item: _withCtx((slot) => [
                          (_openBlock(), _createBlock(_unref(KanbanColumn), {
                            grouping: slot.item.Grouping,
                            key: slot.index,
                            onMouseenter: ($event: any) => (setDraggingColumnIndex(slot.index))
                          }, {
                            indicator: _withCtx(() => [
                              _createVNode(_unref(TasksKanbanColumnIndicator), {
                                grouping: slot.item.Grouping,
                                onMouseenter: ($event: any) => (setColumnDrag(slot.index)),
                                onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (setColumnDrag(undefined)))
                              }, null, 8, ["grouping", "onMouseenter"])
                            ]),
                            count: _withCtx(() => [
                              _createTextVNode(_toDisplayString(slot.item.CountTasks), 1)
                            ]),
                            tools: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_unref(TirPmButton), {
                                  size: _unref(TirPmButtonSizeEnum).Small,
                                  variant: _unref(TirPmButtonVariantEnum).LinkState
                                }, {
                                  leftSlot: _withCtx(() => [
                                    _createVNode(_unref(EllipsisHorizontalIcon))
                                  ]),
                                  _: 1
                                }, 8, ["size", "variant"]),
                                _createVNode(_unref(TirPmButton), {
                                  size: _unref(TirPmButtonSizeEnum).Small,
                                  variant: _unref(TirPmButtonVariantEnum).LinkState,
                                  isDisabled: !_unref(currentQueue)?.IsConfigured || !_unref(isCanAddTask),
                                  onClick: ($event: any) => (openCreateTask(slot.item))
                                }, {
                                  leftSlot: _withCtx(() => [
                                    _createVNode(_unref(PlusIcon))
                                  ]),
                                  _: 2
                                }, 1032, ["size", "variant", "isDisabled", "onClick"])
                              ])
                            ]),
                            cards: _withCtx(() => [
                              _createVNode(_unref(TirPmScrollbar), {
                                showOnHover: "",
                                enableVerticalAutoscroll: scrollCurrentColumn(slot.index),
                                class: "tasks-kanban__column-scroll",
                                onOnScroll: ($event: any) => (_unref(onScrollColumn)($event, slot.index))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: "tasks-kanban__task-column-list",
                                    style: _normalizeStyle({
                          height: !slot.item.Data?.length && _unref(currentDragTask) ? '20rem' : 'auto',
                        })
                                  }, [
                                    _createVNode(_unref(KanbanDraggableSorting), {
                                      dataClass: "tasks-kanban__task-card-drag book-lesson",
                                      data: slot.item.Data,
                                      outerIsDrag: _unref(isDrag),
                                      isAllowPlug: "",
                                      disableSideIndent: true,
                                      "outer-current-dragging": 
                            _unref(currentDragTaskColumnIndex) !== undefined &&
                            slot.index !== _unref(currentDragTaskColumnIndex)
                              ? _unref(currentDragTask)
                              : undefined
                          ,
                                      "clean-flag": _unref(cleanFlag),
                                      indent: 0,
                                      "is-allow-click-delay": "",
                                      onDragComponentOnDrag: 
                            (_isDrag, model) =>
                              _unref(onDrag)(_isDrag, model, slot.index)
                          ,
                                      onAdded: ($event: any) => (_unref(onAdded)(slot.index, $event)),
                                      onChange: ($event: any) => (_unref(onChange)(slot.index, $event, slot.item.Data)),
                                      onCancel: ($event: any) => (_unref(onCancel)($event, slot.index))
                                    }, {
                                      item: _withCtx(({ item }) => [
                                        (tasksIndexed.value[item.TaskId])
                                          ? (_openBlock(), _createBlock(_unref(TaskKanbanCard), {
                                              key: 0,
                                              class: _normalizeClass({ 'tasks-kanban__task-card--event-none': _unref(currentDragTask) }),
                                              task: tasksIndexed.value[item.TaskId],
                                              userAccess: userAccess.value,
                                              "view-settings": taskViewSettings.value,
                                              "groupping-type": _unref(grouppingType),
                                              "project-id": __props.projectId,
                                              "queue-id": __props.queueId,
                                              isProjectAdmin: isProjectAdmin.value,
                                              onToggleSubmenu: _cache[3] || (_cache[3] = ($event: any) => (emit('toggle-submenu', $event))),
                                              onLoadSubtasks: ($event: any) => (_unref(loadSubtasks)(item.TaskId)),
                                              onOpenInDrawer: openTaskInDrawer,
                                              onRemove: openRemoveModal
                                            }, null, 8, ["class", "task", "userAccess", "view-settings", "groupping-type", "project-id", "queue-id", "isProjectAdmin", "onLoadSubtasks"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["data", "outerIsDrag", "outer-current-dragging", "clean-flag", "onDragComponentOnDrag", "onAdded", "onChange", "onCancel"])
                                  ], 4)
                                ]),
                                _: 2
                              }, 1032, ["enableVerticalAutoscroll", "onOnScroll"])
                            ]),
                            _: 2
                          }, 1032, ["grouping", "onMouseenter"]))
                        ]),
                        _: 1
                      }, 8, ["class", "data"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(isLoading) && !_unref(currentQueue)?.IsConfigured && _unref(currentQueue)?.Id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(TirPmSystemMessage, null, {
            topDescImage: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_unref(TirPmIconView), { style: {"width":"5rem","height":"5rem"} }, {
                  mainSlot: _withCtx(() => [
                    _createVNode(_unref(ListBulletIcon), { style: {"width":"3.5rem","height":"3.5rem","color":"var(--neutral-70, #686c73)"} })
                  ]),
                  _: 1
                })
              ])
            ]),
            mainTitleSlot: _withCtx(() => [
              _createTextVNode("Настройте очередь, чтобы"),
              _hoisted_8,
              _createTextVNode(" создать в ней задачи ")
            ]),
            descriptionSlot: _withCtx(() => [
              _createTextVNode("Достаточно добавить 1 статус ")
            ]),
            actionsSlot: _withCtx(() => [
              _createVNode(_unref(TirPmButton), {
                variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                size: _unref(TirPmButtonSizeEnum).Regular,
                onClick: openOptions
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Перейти к настройкам очереди ")
                ]),
                _: 1
              }, 8, ["variant", "size"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (
        _unref(currentQueue)?.IsConfigured && !countTasks.value && !_unref(isLoading) && !_unref(filter).Search && !_unref(grouppingType)
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(TirPmSystemMessage, null, {
            topDescImage: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_unref(TirPmIconView), { style: {"width":"5rem","height":"5rem"} }, {
                  mainSlot: _withCtx(() => [
                    _createVNode(_unref(DimondIcon), { style: {"width":"3.5rem","height":"3.5rem","color":"var(--neutral-70, #686c73)"} })
                  ]),
                  _: 1
                })
              ])
            ]),
            mainTitleSlot: _withCtx(() => [
              _createTextVNode(_toDisplayString(createTaskPlaceholderText.value), 1)
            ]),
            descriptionSlot: _withCtx(() => []),
            actionsSlot: _withCtx(() => [
              (_unref(isCanAddTask))
                ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                    key: 0,
                    variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                    size: _unref(TirPmButtonSizeEnum).Regular,
                    onClick: createTask
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Создать задачу ")
                    ]),
                    _: 1
                  }, 8, ["variant", "size"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    ((_unref(filter).Search && !countTasks.value) || (_unref(grouppingType) && !countTasks.value))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_unref(TirPmIconView), { style: {"width":"5rem","height":"5rem"} }, {
            mainSlot: _withCtx(() => [
              _createVNode(_unref(MagnifyingGlassIcon), { class: "magnifying-glass-icon" })
            ]),
            _: 1
          }),
          _hoisted_11,
          (_unref(filter).Search && !countTasks.value)
            ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                key: 0,
                variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                size: _unref(TirPmButtonSizeEnum).Regular,
                onClick: resetSearch
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Сбросить поиск ")
                ]),
                _: 1
              }, 8, ["variant", "size"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(TaskKanbanSkeleton),
            _createVNode(TaskKanbanSkeleton),
            _createVNode(TaskKanbanSkeleton),
            _createVNode(TaskKanbanSkeleton)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(TaskDrawer), {
      ref_key: "$taskDrawer",
      ref: $taskDrawer,
      onOnCreateTask: onCreateTask,
      onOnUpdateTask: onUpdateTask,
      onSubtaskItem: updateTask,
      onRemoveSubtaskItem: removeSubtaskItem,
      onSuccessRemove: onSuccessRemove
    }, null, 512),
    _createVNode(_unref(RemoveTaskModal), {
      ref_key: "$removeTaskModal",
      ref: $removeTaskModal,
      onSuccessRemove: onSuccessRemove
    }, null, 512)
  ]))
}
}

})